import { useMutation, useQuery } from '@tanstack/react-query';
import { Divider, Select } from 'antd';
import { MyCompletedWorks } from 'components/MyCompletedWorks';
import { observer } from 'mobx-react-lite';
import { ICompletedWork, IKeys, IWork, IWorkState, IWorkStatus } from 'models';
import { useState } from 'react';
import { workService } from 'services';
import { userStore } from 'stores';

interface IUpdateWork {
	data: Partial<IWork> | any,
	id: number
}

export const MoversSalary = observer(() => {
	const [userId, setUserId] = useState<undefined | number>(userStore.isAdmin ? undefined : userStore.data?.id);
	const { data, isLoading } = useQuery({
		queryKey: [IKeys.WORKS, { user: userId, state: IWorkState.COMPLETED }],
		queryFn: () => workService.getByUser(userId || 0, { state: IWorkState.COMPLETED }),
		enabled: !!userId
	});

	const { mutate } = useMutation({
		mutationFn: ({ data, id }: IUpdateWork) => workService.update(data, id)
	});

	const updateWork = (work: ICompletedWork, status: IWorkStatus) => {
		const data = {
			acf: {
				foreman_info: {
					workers: work.workers.map((el) => {
						if (el.worker === work.worker.worker) {
							return { ...el, worker: el.worker, status: !status };
						}
						return { ...el, worker: el.worker };
					})
				}
			}
		};
		mutate({ data, id: work.id });
	};
	return (
		<>
			{userStore.isAdmin && (
				<Select
					onSelect={setUserId}
					showSearch
					style={{ width: 300 }}
					placeholder="Enter name"
					size="large"
					options={userStore.helpersForemans.map(el => ({ value: el.id.toString(), label: el.name }))}
				/>
			)
			}
			<Divider />
			<MyCompletedWorks
				isFetching={isLoading}
				updateWork={updateWork}
				data={data}
			/>
		</>
	);
});

